// Generated by BUCKLESCRIPT, PLEASE EDIT WITH CARE
'use strict';

var $dot$dot = require("..");
var Block = require("bs-platform/lib/js/block.js");
var Js_dict = require("bs-platform/lib/js/js_dict.js");
var Belt_List = require("bs-platform/lib/js/belt_List.js");
var Belt_Option = require("bs-platform/lib/js/belt_Option.js");
var BeltHoles_List = require("belt-holes/src/BeltHoles_List.bs.js");
var Belt_MapString = require("bs-platform/lib/js/belt_MapString.js");
var Pin$XodProject = require("./Pin.bs.js");
var Link$XodProject = require("./Link.bs.js");
var Node$XodProject = require("./Node.bs.js");
var Buses$XodProject = require("./Buses.bs.js");
var Patch$XodProject = require("./Patch.bs.js");
var Project$XodProject = require("./Project.bs.js");
var Either$XodFuncTools = require("xod-func-tools/src/Either.bs.js");
var BeltHoles_Map_String = require("belt-holes/src/BeltHoles_Map_String.bs.js");

function fromJsDict(drs) {
  return Belt_MapString.map(BeltHoles_Map_String.fromDict(drs), (function (nodeTypesDict) {
                return Belt_MapString.map(BeltHoles_Map_String.fromDict(nodeTypesDict), Either$XodFuncTools.toResult);
              }));
}

function toJsDict(drs) {
  return Js_dict.map((function (nodeTypesMap) {
                return Js_dict.map(Either$XodFuncTools.fromResult, BeltHoles_Map_String.toDict(nodeTypesMap));
              }), BeltHoles_Map_String.toDict(drs));
}

function get(drs, nodeId, pinKey) {
  return Belt_Option.flatMap(Belt_MapString.get(drs, nodeId), (function (nodeTypes) {
                return Belt_MapString.get(nodeTypes, pinKey);
              }));
}

function assoc(drs, nodeId, pinKey, res) {
  var updatedNodeTypes = Belt_MapString.set(Belt_MapString.getWithDefault(drs, nodeId, Belt_MapString.empty), pinKey, res);
  return Belt_MapString.set(drs, nodeId, updatedNodeTypes);
}

function dissoc(drs, nodeId, pinKey) {
  var updatedNodeTypes = Belt_MapString.remove(Belt_MapString.getWithDefault(drs, nodeId, Belt_MapString.empty), pinKey);
  if (Belt_MapString.isEmpty(updatedNodeTypes)) {
    return Belt_MapString.remove(drs, nodeId);
  } else {
    return Belt_MapString.set(drs, nodeId, updatedNodeTypes);
  }
}

var ResultsMap = {
  fromJsDict: fromJsDict,
  toJsDict: toJsDict,
  get: get,
  assoc: assoc,
  dissoc: dissoc
};

function deducePinTypes(originalPatch, project) {
  var matchingBusNodes = Buses$XodProject.getMatchingBusNodes(originalPatch);
  var linkifiedPatch = Buses$XodProject.linkifyPatch(originalPatch, matchingBusNodes);
  var deductionResultsForLinkifiedPatch = fromJsDict($dot$dot.deducePinTypesWithoutBuses(linkifiedPatch, project));
  var match = Belt_List.length(matchingBusNodes);
  if (match !== 0) {
    var linksByInputNodeId = BeltHoles_List.groupByString(Patch$XodProject.listLinks(originalPatch), Link$XodProject.getInputNodeId);
    return Belt_List.reduce(matchingBusNodes, deductionResultsForLinkifiedPatch, (function (deductionResults, param) {
                  var fromBusNodes = param[1];
                  var toBusNodeId = Node$XodProject.getId(param[0]);
                  return Belt_Option.mapWithDefault(Belt_Option.flatMap(Belt_MapString.get(linksByInputNodeId, toBusNodeId), Belt_List.head), deductionResults, (function (linkFromSource) {
                                var sourceNodeId = Link$XodProject.getOutputNodeId(linkFromSource);
                                var sourcePinKey = Link$XodProject.getOutputPinKey(linkFromSource);
                                var match = get(deductionResults, sourceNodeId, sourcePinKey);
                                var deductionResultForSourceOutput = match !== undefined ? match : Belt_Option.mapWithDefault(Belt_Option.map(Belt_Option.flatMap(Belt_Option.flatMap(Patch$XodProject.getNodeById(originalPatch, sourceNodeId), (function (param) {
                                                      return Project$XodProject.getPatchByNode(project, param);
                                                    })), (function (__x) {
                                                  return Patch$XodProject.getPinByKey(__x, sourcePinKey);
                                                })), Pin$XodProject.getType), /* Error */Block.__(1, [[]]), (function (pinType) {
                                          return /* Ok */Block.__(0, [pinType]);
                                        }));
                                var fromBusNodeIds = Belt_List.map(fromBusNodes, Node$XodProject.getId);
                                var drs = assoc(deductionResults, toBusNodeId, "__in__", deductionResultForSourceOutput);
                                return Belt_List.reduce(fromBusNodeIds, drs, (function (accDrs, nodeId) {
                                              return assoc(accDrs, nodeId, "__out__", deductionResultForSourceOutput);
                                            }));
                              }));
                }));
  } else {
    return deductionResultsForLinkifiedPatch;
  }
}

exports.ResultsMap = ResultsMap;
exports.deducePinTypes = deducePinTypes;
/* .. Not a pure module */



// WEBPACK FOOTER //
// ../src/TypeDeduction.bs.js